import { current } from "@reduxjs/toolkit";
import api from "./api";
import UserService from "./user.service";
import { useSelector } from "react-redux";
import { isAccountant, isAdmin } from "src/Common/function";

const getAll = (keyword) => {
  return api.get("/api/customer/get_all", { params: { keyword } });
};

const saveCustomer = (customer) => {
  return api.post("/api/customer/add_customer", customer);
};

const archiveCustomer = (id) => {
  return api.post("/api/customer/archive_customer", { customerId: id });
};

const updateCustomer = (customer) => {
  return api.post("/api/customer/update_customer", { ...customer });
};

const getOne = (customerId) => {
  return api.get("/api/customer/get_one", { params: { customerId } });
};

const CustomerService = {
  getOne,
  getAll,
  saveCustomer,
  archiveCustomer,
  updateCustomer,
};

export default CustomerService;
